export default function initM5() {
   const $ = jQuery
$(document).on('ready', function() {
    $(".vertical-slider").slick({
       dots: false,
       infinite: true,
       arrows:false,
       vertical: true,
       slidesToShow: 2,
       slidesToScroll: 1,
       autoplay: true,
       speed: 5000,
       autoplaySpeed: 0,
       cssEase: 'linear',
       responsive: [
          {
             breakpoint: 991,
             settings: {
                vertical: false,
                variableWidth: true,speed: 3000,
             }
          }
       ]
       });
       $(".vertical-slider-rtl").slick({
        dots: false,
        infinite: true,
        arrows:false,
        vertical: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        speed: 5000,
        autoplaySpeed: 0, 
        cssEase: 'linear',
        responsive: [
           {
              breakpoint: 991,
              settings: {
                 vertical: false,
                 variableWidth: true,speed: 3000,
              }
           }
        ]
        });
});
}